import { getKey } from '../utils/uid';
export default function splitSelecteds(selecteds, props) {
  if (!selecteds) return null;
  var data = props.data,
      keygen = props.keygen,
      datum = props.datum;
  var left = [];
  var right = [];
  selecteds.forEach(function (s) {
    var v = data.find(function (d, i) {
      return getKey(d, keygen, i) === s;
    });

    if (v) {
      if (datum.check(v)) right.push(s);else left.push(s);
    }
  });
  var result = [left, right];
  return result;
}